import React from "react";
import { Helmet } from "react-helmet-async";
import { useSiteSeo } from "../../context/SiteSeoContext";
import { getCanonicalSiteOrigin } from "../../utils/siteUrl";

/** Search Console / Bing verification meta (values from Admin SEO or env). */
export function GlobalVerificationHelmet() {
  const s = useSiteSeo();
  return (
    <Helmet>
      {s.google_site_verification ? (
        <meta name="google-site-verification" content={String(s.google_site_verification)} />
      ) : null}
      {s.bing_site_verification ? (
        <meta name="msvalidate.01" content={String(s.bing_site_verification)} />
      ) : null}
    </Helmet>
  );
}

/** Organization + WebSite JSON-LD for the whole storefront. */
export default function GlobalJsonLd() {
  const s = useSiteSeo();
  const origin = getCanonicalSiteOrigin();
  if (!origin) return null;

  const orgUrl = (s.organization_url || origin || "").trim().replace(/\/+$/, "");
  const name = (s.organization_name || "Gem Fashion Studios").trim();
  const logo = (s.organization_logo_url || "").trim();

  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name,
    url: orgUrl || origin,
    inLanguage: "en",
    ...(logo ? { logo } : {}),
    ...(Array.isArray(s.same_as) && s.same_as.length ? { sameAs: s.same_as } : {}),
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name,
    url: origin,
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(org)}</script>
      <script type="application/ld+json">{JSON.stringify(website)}</script>
    </Helmet>
  );
}
